import Visitors from '@/components/Visitors';

const VisitorsPage = () => {
  return <Visitors />;
};

export default VisitorsPage;
